import React from 'react';
import { withStyles } from '@material-ui/styles';
import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import { Link as RouterLink } from 'react-router-dom';
import TotalUsers from '../TotalUsers';
import {
    Grid,
    Paper,
    TextField,
    Container,
    Button,
    MenuItem,
    InputAdornment,
    IconButton,
    Typography,
    Divider
} from '@material-ui/core';

const styles = theme => ({
    root: {
        padding: theme.spacing(4)
    },
    paper: {
        padding: '32px 48px 32px 48px'
    },
    button: {
        width: '100%',
        textAlign: 'center',
        marginTop: 40
    },
    paperHeader: {
        padding: 10
    }
});

const roles = [
    {
        nom: 'Placier',
        id: 'Placier'
    },
    {
        nom: 'Administrateur',
        id: 'Administrateur'
    },
    {
        nom: 'Régisseur',
        id: 'Regisseur'
    }
];

class Add extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            ...props,
            username: '',
            role: '',
            mdp: '',
            email: '',
            mdpVerif: '',
            showPassword: false,
            config: {
                nombre: 0,
                last: ''
            }
        };
    }

    componentDidMount = () => {
        fetch(
            `https://www.${
                window.location.hostname.split('.')[1]
                    ? window.location.hostname.split('.')[0] === 'www'
                        ? window.location.hostname.split('.')[1]
                        : window.location.hostname.split('.')[0]
                    : 'dev'
            }.api.digitmarche.fr/api/administrateur/settings`
        )
            .then(res => res.json()) // Traitement en json
            .then(data => {
                // Traitement de l'indo for stating data
                this.setState({
                    config: {
                        nombre:
                            data.administrateur_settings.les_utilisateurs
                                .nombre_utilisateurs_enregistres,
                        last:
                            data.administrateur_settings.les_utilisateurs
                                .dernier_utilisateur_enregistre
                    }
                });
            })
            .catch(console.log);
    };

    handleMerchantForm = ({ target: { name, value } }) => {
        this.setState({
            [name]: value
        });
    };

    showPasswd = value => {
        this.setState({
            showPassword: value
        });
    };

    handleCreate = () => {
        const { username, role, mdp, mdpVerif, email, history } = this.state;

        if (username == '') {
            alert("Veuillez saisir un nom d'utilisateur");
            return;
        }

        if (email == '') {
            alert('Veuillez saisir une adresse mail');
            return;
        }

        if (role == '') {
            alert('Veuillez sélectionnez un profil');
            return;
        }

        if (mdp == '') {
            alert('Veuillez saisir un mot de passe');
            return;
        }

        if (mdpVerif == '') {
            alert('Veuillez à nouveau saisir votre mot de passe');
            return;
        }

        if (mdp != mdpVerif) {
            alert('Les mots de passe ne sont pas identiques');
            return;
        }

        fetch(
            `https://www.${
                window.location.hostname.split('.')[1]
                    ? window.location.hostname.split('.')[0] === 'www'
                        ? window.location.hostname.split('.')[1]
                        : window.location.hostname.split('.')[0]
                    : 'dev'
            }.api.digitmarche.fr/api/user/add?username=${username}&role=${role}&mdp=${mdp}&email=${email}`
        )
            .then(res => res.json()) // Traitement en json
            .then(data => {
                // Traitement de l'indo for stating data
                if (data) {
                    history.push('/settings/users');
                } else {
                    alert("Ce nom d'utlisateur existe déjà");
                }
            });
    };

    render() {
        const { classes, username, role, mdp, mdpVerif, email, showPassword } = this.state;

        return (
            <Container className={classes.root}>
                <Grid container spacing={4}>
                    <Grid item xs={4}>
                        <TotalUsers data={this.state.config} />
                    </Grid>
                    <Grid item xs={12}>
                        <Paper>
                            <div className={classes.paperHeader}>
                                <Typography variant="h5">
                                    <IconButton
                                        component={RouterLink}
                                        to="/settings/users"
                                        type="button">
                                        <ArrowBackIcon />
                                    </IconButton>
                                    Créer un utilisateur
                                </Typography>
                            </div>
                            <Divider />

                            <div className={classes.paper}>
                                <Grid container spacing={4}>
                                    <Grid item xs={6}>
                                        <TextField
                                            fullWidth
                                            name="username"
                                            id="username"
                                            label="Nom d'utilisateur"
                                            type="text"
                                            onChange={this.handleMerchantForm}
                                            helperText="Saisir un nom d'utilisateur"
                                            value={username}
                                            variant="outlined"
                                        />
                                    </Grid>
                                    <Grid item xs={6}>
                                        <TextField
                                            fullWidth
                                            name="email"
                                            id="email"
                                            label="Email"
                                            type="text"
                                            onChange={this.handleMerchantForm}
                                            helperText="Saisir une adresse mail"
                                            value={email}
                                            variant="outlined"
                                        />
                                    </Grid>
                                    <Grid item xs={6}>
                                        <TextField
                                            fullWidth
                                            name="role"
                                            id="role"
                                            label="Rôle du profil"
                                            type="text"
                                            select
                                            onChange={this.handleMerchantForm}
                                            helperText="Choisir un rôle"
                                            value={role}
                                            variant="outlined">
                                            {roles.map((role, index) => (
                                                <MenuItem key={role.id} value={role.id}>
                                                    {role.nom}
                                                </MenuItem>
                                            ))}
                                        </TextField>
                                    </Grid>
                                </Grid>
                                <Grid container spacing={4}>
                                    <Grid item xs={6}>
                                        <TextField
                                            fullWidth
                                            name="mdp"
                                            id="mdp"
                                            type={showPassword ? 'text' : 'password'}
                                            label="Mot de passe"
                                            onChange={this.handleMerchantForm}
                                            helperText="Saisir un mot de passe"
                                            value={mdp}
                                            variant="outlined"
                                            InputProps={{
                                                endAdornment: (
                                                    <InputAdornment position="end">
                                                        <IconButton
                                                            onClick={() =>
                                                                this.showPasswd(!showPassword)
                                                            }>
                                                            {showPassword ? (
                                                                <Visibility />
                                                            ) : (
                                                                <VisibilityOff />
                                                            )}
                                                        </IconButton>
                                                    </InputAdornment>
                                                )
                                            }}
                                        />
                                    </Grid>
                                    <Grid item xs={6}>
                                        <TextField
                                            fullWidth
                                            name="mdpVerif"
                                            id="mdpVerif"
                                            type={showPassword ? 'text' : 'password'}
                                            label="Vérification mot de passe"
                                            onChange={this.handleMerchantForm}
                                            helperText="Saisir à nouveau votre mot de passe"
                                            value={mdpVerif}
                                            variant="outlined"
                                            InputProps={{
                                                endAdornment: (
                                                    <InputAdornment position="end">
                                                        <IconButton
                                                            onClick={() =>
                                                                this.showPasswd(!showPassword)
                                                            }>
                                                            {showPassword ? (
                                                                <Visibility />
                                                            ) : (
                                                                <VisibilityOff />
                                                            )}
                                                        </IconButton>
                                                    </InputAdornment>
                                                )
                                            }}
                                        />
                                    </Grid>
                                </Grid>

                                <div className={classes.button}>
                                    <Button
                                        variant="contained"
                                        color="primary"
                                        onClick={this.handleCreate}>
                                        Créer cet utilisateur
                                    </Button>
                                </div>
                            </div>
                        </Paper>
                    </Grid>
                </Grid>
            </Container>
        );
    }
}

export default withStyles(styles)(Add);
